import { render, staticRenderFns } from "./MachineShop.vue?vue&type=template&id=b361b2c8&"
import script from "./MachineShop.vue?vue&type=script&lang=js&"
export * from "./MachineShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports